import { EventEmitter } from "eventemitter3";

export interface AnomalyOnboardingEmitterType {
    resetOnboarding: (onboardingStorageKey: string) => unknown;
}

export const anomalyOnboardingEmitter = new EventEmitter<AnomalyOnboardingEmitterType>();
